<div class="emission-register-page">

  <div class="page-intro">
    <b3-breadcrumbs aria-label="Breadcrumb">
      <b3-breadcrumbs-item variant="icon" href="/consulta-emissao-credito"></b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Registro de projetos e emissão de créditos</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Emissão de Créditos</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Emissão</b3-breadcrumbs-item>
    </b3-breadcrumbs>
    <h1 class="page-title">Emitir Créditos</h1>
  </div>

  <form class="emission-register-form" [formGroup]="formRegister">
    <div class="form-layout">
      <div class="form-panel">
      <div class="form-shell">
        <section class="section-card">
          <div class="section-card__header">
            <div class="section-card__heading">
              <div class="section-header">
                <span class="section-header__accent" aria-hidden="true"></span>
                <h2 class="section-header__title">Responsável</h2>
              </div>
            </div>
            <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
          </div>

          <div class="fields-row fields-row--2">
            <div class="field-group field-group--labeled">
              <b3-input-text
                formControlName="holderCode"
                inputId="holderCode"
                label="Detentor"
                background="white"
                mask="account"
                placeholder="00000.00-0"
                [error]="checkHasError('holderCode')"
                [hint]="[
                  { show: checkHasError('holderCode', 'required'), text: 'Campo obrigatório' },
                  { show: checkHasError('holderCode', 'invalidChar'), text: 'Insira uma conta miolo (00) ou miolo (10)' },
                  { show: checkHasError('holderCode'), text: 'Preenchimento inválido' }
                ] | fieldHint">
              </b3-input-text>
            </div>

            <div class="field-group field-group--labeled">
              <b3-input-text
                formControlName="cpfCnpjCode"
                inputId="cpfCnpjCode"
                label="CPF/CNPJ Desenvolvedor"
                background="white"
                [mask]="developerDocumentMask"
                placeholder="000.000.000-00"
                [disabled]="true"
                [error]="checkHasError('cpfCnpjCode')"
                [hint]="[
                  { show: checkHasError('cpfCnpjCode', 'required'), text: 'Campo obrigatório' },
                  { show: checkHasError('cpfCnpjCode'), text: 'Preenchimento inválido' }
                ] | fieldHint">
              </b3-input-text>
            </div>
          </div>
        </section>
      </div>

      <div class="form-shell">
        <section class="section-card">
          <div class="section-card__header">
            <div class="section-card__heading">
              <div class="section-header">
                <span class="section-header__accent" aria-hidden="true"></span>
                <h2 class="section-header__title">Projeto gerador de créditos</h2>
              </div>
            </div>
            <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
          </div>

          <div class="fields-row fields-row--1">
            <div class="field-group field-group--labeled">
              <b3-input-select
                formControlName="project"
                inputId="project"
                label="Projeto"
                placeholder="Selecione o projeto"
                background="white"
                maxHeight="280px"
                [options]="selectItens"
                [error]="checkHasError('project')"
                [hint]="[
                  { show: checkHasError('project', 'required'), text: 'Campo obrigatório' }
                ] | fieldHint"
                (b3-change)="onProjectChange()">
                <b3-input-select-option
                  *ngFor="let item of selectItens; let i = index"
                  [attr.value]="item.inputId"
                  [attr.index]="i"
                  [id]="'project-option-' + item.inputId">
                  {{ item.label }}
                </b3-input-select-option>
              </b3-input-select>
            </div>
          </div>

          <div class="fields-row fields-row--2">
            <div class="field-group field-group--labeled">
              <b3-input-text
                formControlName="emissionNumber"
                inputId="emissionNumber"
                label="Número de emissão"
                background="white"
                mask="text"
                placeholder="0000000"
                [disabled]="true">
              </b3-input-text>
            </div>

            <div class="field-group field-group--labeled">
              <div class="input-with-suffix">
                <b3-input-text
                  formControlName="totalQuantity"
                  inputId="totalQuantity"
                  label="Quantidade total"
                  background="white"
                  mask="integer"
                  placeholder="00000000"
                  [disabled]="true">
                </b3-input-text>
                <span class="input-with-suffix__suffix">tCO2</span>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="form-shell">
        <section class="section-card">
          <div class="section-card__header">
            <div class="section-card__heading">
              <div class="section-header">
                <span class="section-header__accent" aria-hidden="true"></span>
                <h2 class="section-header__title">Período de geração de créditos</h2>
              </div>
            </div>
            <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
          </div>

          <div class="fields-row fields-row--2">
            <div class="field-group field-group--labeled">
              <b3-datepicker
                inputId="startDate"
                label="Data inicial"
                formControlName="startDate"
                background="white"
                placeholder="DD/MM/AAAA"
                locale="pt-BR"
                [min]="minDateIso"
                [max]="maxStartDateIso"
                [error]="checkHasError('startDate') || showDateRangeError('startDate')"
                [hint]="[
                  { show: checkDateFieldError('startDate', 'required'), text: 'Campo obrigatório' },
                  { show: showDateRangeError('startDate'), text: 'Data inválida' }
                ] | fieldHint"
                (b3-change)="onStartDateChange($event)">
              </b3-datepicker>
            </div>

            <div class="field-group field-group--labeled">
              <b3-datepicker
                inputId="endDate"
                label="Data final"
                formControlName="endDate"
                background="white"
                placeholder="DD/MM/AAAA"
                locale="pt-BR"
                [min]="minEndDateIso"
                [max]="maxDateIso"
                [error]="checkHasError('endDate') || showDateRangeError('endDate')"
                [hint]="[
                  { show: checkDateFieldError('endDate', 'required'), text: 'Campo obrigatório' },
                  { show: showDateRangeError('endDate'), text: 'Data inválida' }
                ] | fieldHint"
                (b3-change)="onEndDateChange($event)">
              </b3-datepicker>
            </div>
          </div>
        </section>
      </div>

      <div class="form-shell">
        <section class="section-card">
          <div class="section-card__header section-card__header--with-action">
            <div class="section-card__heading">
              <div class="section-header">
                <span class="section-header__accent" aria-hidden="true"></span>
                <h2 class="section-header__title">Safra</h2>
              </div>
            </div>
            <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
          </div>

          <div class="harvest-fields">
            <div class="fields-row fields-row--2">
              <div class="field-group field-group--labeled">
                <b3-input-text
                  formControlName="harvestYear"
                  inputId="harvestYear"
                  label="Ano da safra"
                  background="white"
                  mask="integer"
                  placeholder="Inserir"
                  [error]="checkHasError('harvestYear') || showHarvestYearPeriodError()"
                  [hint]="[
                    { show: checkHasError('harvestYear', 'required'), text: 'Campo obrigatório' },
                    { show: checkHarvestYearPeriodError('harvestBeforePeriod'), text: 'Ano da safra não pode ser anterior ao período de geração de créditos' },
                    { show: checkHarvestYearPeriodError('harvestAfterPeriod'), text: 'Ano da safra deve estar dentro do período de geração de créditos' }
                  ] | fieldHint">
                </b3-input-text>
              </div>

              <div class="field-group field-group--labeled">
                <b3-input-text
                  formControlName="harvestQuantity"
                  inputId="harvestQuantity"
                  label="Créditos gerados nesta safra"
                  background="white"
                  mask="integer"
                  placeholder="Inserir"
                  [error]="checkHasError('harvestQuantity')">
                </b3-input-text>
              </div>
            </div>

            <div class="fields-row fields-row--1">
              <div class="field-group field-group--labeled">
                <b3-input-select
                  formControlName="developer"
                  inputId="developer"
                  label="Desenvolvedor responsável"
                  placeholder="Selecione o desenvolvedor"
                  background="white"
                  maxHeight="240px"
                  [options]="developerSelectItens"
                  [error]="checkHasError('developer')">
                  <b3-input-select-option
                    *ngFor="let item of developerSelectItens; let i = index"
                    [attr.value]="item.inputId"
                    [attr.index]="i"
                    [id]="'developer-option-' + item.inputId">
                    {{ item.label }}
                  </b3-input-select-option>
                </b3-input-select>
              </div>
            </div>
          </div>

          <div class="harvest-actions">
            <b3-button
              type="button"
              variant="outlined"
              tone="default"
              (b3-click)="addEmissionVintage()">
              <b3-icon name="add" size="sm"></b3-icon>
              Incluir nova
            </b3-button>
          </div>

          <div class="harvest-table-block" *ngIf="itens.length">
            <app-field-message [show]="invalidTableHarvestItems" status="error">
              Existem safras incluídas fora do período de geração de créditos. Remova-as ou ajuste o período.
            </app-field-message>

            <div class="harvest-table__header">
              <h3 class="harvest-table__title">Safras incluídas</h3>
              <span class="harvest-table__count">{{ itens.length }}</span>
            </div>

            <table class="harvest-table" aria-label="Safras incluídas">
              <thead>
                <tr>
                  <th scope="col">Ano</th>
                  <th scope="col">Créditos gerados</th>
                  <th scope="col">Desenvolvedor</th>
                  <th scope="col" class="harvest-table__cell--actions">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of itens">
                  <td>{{ row.harvestYear }}</td>
                  <td>{{ row.quantity }}</td>
                  <td>{{ row.developerName }}</td>
                  <td class="harvest-table__cell--actions">
                    <button
                      type="button"
                      class="harvest-table__action-btn"
                      aria-label="Remover safra"
                      (click)="removeEmissionVintage(row)">
                      <b3-icon name="delete" size="md" tone="default"></b3-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <div class="form-shell">
        <section class="section-card">
          <div class="section-card__header">
            <div class="section-card__heading">
              <div class="section-header">
                <span class="section-header__accent" aria-hidden="true"></span>
                <h2 class="section-header__title">Relatório de Monitoramento (RM)</h2>
              </div>
            </div>
            <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
          </div>

          <div class="fields-row fields-row--1">
            <div class="field-group field-group--labeled">
              <b3-input-text
                formControlName="rmLink"
                inputId="rmLink"
                label="Link do Relatório de Monitoramento (RM)"
                background="white"
                mask="link"
                placeholder="Limite 100 caracteres"
                [maxlength]="100"
                [error]="checkHasError('rmLink')"
                [hint]="[
                  { show: checkHasError('rmLink', 'required'), text: 'Campo obrigatório' },
                  { show: checkHasError('rmLink', 'maxlength'), text: 'Limite de 100 caracteres atingido' },
                  { show: checkHasError('rmLink', 'pattern'), text: 'Link inválido' }
                ] | fieldHint">
              </b3-input-text>
            </div>
          </div>

          <div class="fields-row fields-row--1">
            <div class="field-group field-group--labeled">
              <b3-input-area
                formControlName="details"
                inputId="details"
                label="Detalhes"
                background="white"
                placeholder="Limite 500 caracteres"
                [maxlength]="500"
                [error]="checkHasError('details')"
                [hint]="[
                  { show: checkHasError('details', 'required'), text: 'Campo obrigatório' },
                  { show: checkHasError('details', 'maxlength'), text: 'Limite de 500 caracteres atingido' }
                ] | fieldHint">
              </b3-input-area>
              <p class="character-count" [class.character-count--limit]="characterCount >= 500">
                {{ characterCount }}/500
              </p>
            </div>
          </div>
        </section>
      </div>

      <div class="form-actions" role="group" aria-label="Ações do formulário">
        <b3-button
          type="button"
          variant="ghost"
          tone="default"
          class="form-actions__btn-clear"
          (b3-click)="cleanForm()">
          Limpar
        </b3-button>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          class="form-actions__btn-submit"
          [disabled]="isButtonDisabled"
          (b3-click)="register()">
          <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
          Emitir Créditos
        </b3-button>
      </div>
      </div>
    </div>
  </form>

  <footer class="page-footer">
    <p class="page-footer__text">B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.</p>
  </footer>
</div>

<app-modal-emission-register-success
  *ngIf="successViewModel"
  [open]="showSuccessModal"
  [viewModel]="successViewModel"
  (action)="onSuccessModalAction($event)">
</app-modal-emission-register-success>

<app-modal-emission-register-error
  *ngIf="errorViewModel"
  [open]="showErrorModal"
  [viewModel]="errorViewModel"
  (action)="onErrorModalAction($event)">
</app-modal-emission-register-error>
